import * as React from 'react';
import { Store } from '../../../../stores';
import { inject, observer } from 'mobx-react';
import { LocalizationService } from '../../../../../../services/LocalizationService';
import { IAToggle } from '../../../../../toggle/Toggle';
import { IATextField } from '../../../../../textField/TextField';
import { IAGroup } from '../../../../../group/Group';
import { IANumberField } from '../../../../../numberField/NumberField';
import { IPlayTimeEditType } from '../../../../../../interfaces/IPlay';
import { IAColorPicker } from '../../../../../..';
import * as styles from '../WidgetEditPanel.css';
import { IACheckbox } from '../../../../../checkbox/Checkbox';

export interface IProps {
  store?: Store;
  forceUpdate: () => void;
  reloadPreview: () => void;
  loadingContent: (loading: boolean) => void
}

export interface IState {
  isLoadingTypes: boolean;
  types: IPlayTimeEditType[];
  showAddFilterPopup: boolean;
}

@inject('store')
@observer
export class OutlookCalendarWidgetSettings extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      isLoadingTypes: true,
      types: [],
      showAddFilterPopup: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  render(): React.ReactNode {
    return (
      <>
        <IAGroup
          label={this.localizationService.strings.PlayAdmin_WidgetSettings?.toUpperCase()}
          darkMode={this.props.store.darkMode}
        >
          <div style={{
            display: "flex",
            flexDirection: "column"
          }}>
            <IATextField
              label={this.localizationService.strings.PlayAdmin_WidgetTitle?.toUpperCase()}
              required
              placeholder={this.localizationService.strings.PlayAdmin_WidgetTitle}
              text={this.props.store.widgetToEdit.title}
              darkMode={this.props.store.darkMode}
              highlightColor={this.props.store.highlightColor}
              borderRadius={5}
              labelStyle={{
                fontSize: "12px"
              }}
              onChange={(title: string) => {
                this.props.store.widgetToEdit.title = title;
                this.props.forceUpdate();
              }}
            />
            <IAToggle
              style={{
                marginTop: 20,
                fontSize: 12
              }}
              darkMode={this.props.store.darkMode}
              label={this.localizationService.strings.PlayAdmin_ShowWidgetTitle?.toUpperCase()}
              checked={this.props.store.widgetToEdit.showTitle}
              color={this.props.store.highlightColor}
              onChange={() => {
                this.props.store.widgetToEdit.showTitle = !!!this.props.store.widgetToEdit.showTitle;
                this.props.forceUpdate();
              }}
            />
            <IANumberField
              label={this.localizationService.strings.PlayAdmin_MinimumDuration?.toUpperCase()}
              number={this.props.store.widgetToEdit?.duration}
              darkMode={this.props.store.darkMode}
              highlightColor={this.props.store.highlightColor}
              borderRadius={5}
              labelStyle={{
                fontSize: "12px"
              }}
              onChange={(duration: number) => {
                this.props.store.widgetToEdit.duration = duration;
                this.props.forceUpdate();
              }}
              styles={{
                width: "100%",
                clear: "both"
              }}
            />
            <div className={`${styles.IA_outlookCalendarSelector} ${this.props.store.darkMode ? styles.dark : ''}`}>
              <h4>{this.localizationService.strings.PlayAdmin_OutlookCalendarSelectCalendars}</h4>
              {this.props.store.widgetToEdit.outlookCalendar.resources?.map((calendar) => {
                return <div key={calendar.id} className={styles.IA_outlookCalendarSelectorRow}>
                  <div>
                    {calendar.title}
                  </div>
                  <IACheckbox
                    highlightColor={this.props.store.highlightColor}
                    isChecked={calendar.selected}
                    onChange={(isChecked) => {
                      calendar.selected = isChecked;
                      this.props.forceUpdate();
                    }}
                  />
                </div>
              })
              }
              {/* {
                this.state.isLoadingMore && <div>
                  <IASpinner color={this.props.store.highlightColor} />
                </div>
              } */}
              {
                // this.props.store.widgetToEdit.outlookCalendar.calendars?.length < this.state.playlistsCount && <div className={styles.IA_outlookCalendarSelectorLoadMore}>
                //   <IAButton
                //     label='Load more'
                //     buttonColor={this.props.store.highlightColor}
                //     onClick={() => this.loadPlaylists()}
                //     darkMode={this.props.store.darkMode}
                //   />
                // </div>
              }

            </div>
            <IAColorPicker
              key="IA_themeBackgroundColor"
              label={this.localizationService.strings.PlayAdmin_BackgroundColor.toUpperCase()}
              color={this.props.store.widgetToEdit.outlookCalendar.backgroundColor}
              swatches={this.props.store.profile?.swatches}
              allowAddingToSwatches={false}
              inTeams
              onChange={(backgroundColor: string) => {
                this.props.store.widgetToEdit.outlookCalendar.backgroundColor = backgroundColor;
              }}
              darkMode={this.props.store.darkMode}
              showClearButton={false}
              styles={{
                marginTop: 20,
                float: "left",
                width: "auto",
              }}
            />
            <IAColorPicker
              key="IA_themeBackgroundColor"
              label={this.localizationService.strings.PlayAdmin_HeadlineColor.toUpperCase()}
              color={this.props.store.widgetToEdit.outlookCalendar.headlineColor}
              swatches={this.props.store.profile?.swatches}
              allowAddingToSwatches={false}
              inTeams
              onChange={(headlineColor: string) => {
                this.props.store.widgetToEdit.outlookCalendar.headlineColor = headlineColor;
              }}
              darkMode={this.props.store.darkMode}
              showClearButton={false}
              styles={{
                marginTop: 20,
                float: "left",
                width: "auto",
              }}
            />
            <IAColorPicker
              key="IA_themeTextColor"
              label={this.localizationService.strings.PlayAdmin_TextColor.toUpperCase()}
              color={this.props.store.widgetToEdit.outlookCalendar.textColor}
              swatches={this.props.store.profile?.swatches}
              allowAddingToSwatches={false}
              inTeams
              onChange={(textColor: string) => {
                this.props.store.widgetToEdit.outlookCalendar.textColor = textColor;
              }}
              darkMode={this.props.store.darkMode}
              showClearButton={false}
              styles={{
                marginTop: 20,
                float: "left",
                width: "auto",
              }}
            />
            <IAColorPicker
              key="IA_themeHighlightColor"
              label={this.localizationService.strings.PlayAdmin_HighlightColor.toUpperCase()}
              color={this.props.store.widgetToEdit.outlookCalendar.highlightColor}
              swatches={this.props.store.profile?.swatches}
              allowAddingToSwatches={false}
              inTeams
              onChange={(highlightColor: string) => {
                this.props.store.widgetToEdit.outlookCalendar.highlightColor = highlightColor;
              }}
              darkMode={this.props.store.darkMode}
              showClearButton={false}
              styles={{
                marginTop: 20,
                float: "left",
                width: "auto",
              }}
            />
            <IATextField
              label={this.localizationService.strings.PlayAdmin_Headline?.toUpperCase()}
              placeholder={this.localizationService.strings.PlayAdmin_Headline}
              text={this.props.store.widgetToEdit.outlookCalendar.headline}
              darkMode={this.props.store.darkMode}
              highlightColor={this.props.store.highlightColor}
              borderRadius={5}
              labelStyle={{
                fontSize: "12px"
              }}
              onChange={(headline: string) => {
                this.props.store.widgetToEdit.outlookCalendar.headline = headline;
                this.props.forceUpdate();
              }}
            />
            <IAToggle
              style={{
                marginTop: 20,
                fontSize: 12
              }}
              darkMode={this.props.store.darkMode}
              label={this.localizationService.strings.PlayAdmin_OutlookCalendarShowDate?.toUpperCase()}
              checked={this.props.store.widgetToEdit.outlookCalendar.showDate}
              color={this.props.store.highlightColor}
              onChange={() => {
                this.props.store.widgetToEdit.outlookCalendar.showDate = this.props.store.widgetToEdit.outlookCalendar.showDate != undefined ? !this.props.store.widgetToEdit.outlookCalendar.showDate : true;
                this.props.forceUpdate();
              }}
            />
            <IAToggle
              style={{
                marginTop: 20,
                fontSize: 12
              }}
              darkMode={this.props.store.darkMode}
              label={this.localizationService.strings.PlayAdmin_OutlookCalendarShowTime?.toUpperCase()}
              checked={this.props.store.widgetToEdit.outlookCalendar.showTime}
              color={this.props.store.highlightColor}
              onChange={() => {
                this.props.store.widgetToEdit.outlookCalendar.showTime = this.props.store.widgetToEdit.outlookCalendar.showTime != undefined ? !this.props.store.widgetToEdit.outlookCalendar.showTime : true;
                this.props.forceUpdate();
              }}
            />
            <IAToggle
              style={{
                marginTop: 20,
                fontSize: 12
              }}
              darkMode={this.props.store.darkMode}
              label={this.localizationService.strings.PlayAdmin_OutlookCalendarShowOrganizer?.toUpperCase()}
              checked={this.props.store.widgetToEdit.outlookCalendar.showOrganizer}
              color={this.props.store.highlightColor}
              onChange={() => {
                this.props.store.widgetToEdit.outlookCalendar.showOrganizer = this.props.store.widgetToEdit.outlookCalendar.showOrganizer != undefined ? !this.props.store.widgetToEdit.outlookCalendar.showOrganizer : true;
                this.props.forceUpdate();
              }}
            />
            <IAToggle
              style={{
                marginTop: 20,
                fontSize: 12
              }}
              darkMode={this.props.store.darkMode}
              label={this.localizationService.strings.PlayAdmin_OutlookCalendarShowRoom?.toUpperCase()}
              checked={this.props.store.widgetToEdit.outlookCalendar.showRoom}
              color={this.props.store.highlightColor}
              onChange={() => {
                this.props.store.widgetToEdit.outlookCalendar.showRoom = this.props.store.widgetToEdit.outlookCalendar.showRoom != undefined ? !this.props.store.widgetToEdit.outlookCalendar.showRoom : true;
                this.props.forceUpdate();
              }}
            />
            <IAToggle
              style={{
                marginTop: 20,
                fontSize: 12
              }}
              darkMode={this.props.store.darkMode}
              label={this.localizationService.strings.PlayAdmin_OutlookCalendarShowMeetingTitle?.toUpperCase()}
              checked={this.props.store.widgetToEdit.outlookCalendar.showMeetingTitle}
              color={this.props.store.highlightColor}
              onChange={() => {
                this.props.store.widgetToEdit.outlookCalendar.showMeetingTitle = this.props.store.widgetToEdit.outlookCalendar.showMeetingTitle != undefined ? !this.props.store.widgetToEdit.outlookCalendar.showMeetingTitle : true;
                this.props.forceUpdate();
              }}
            />
          </div>
        </IAGroup>
      </>
    );
  }
}
